export const validateEquality = (val1: unknown, val2: unknown) => val1 === val2;
